module.exports = __webpack_public_path__ + "img/and_default.80984605.png";